import type { ConversationNodeVoicemail } from 'lib-shared-types-api';

type RoutedThroughVoicemailProps = {
  node: ConversationNodeVoicemail;
};

export function RoutedThroughVoicemail({
  node,
}: RoutedThroughVoicemailProps): JSX.Element {
  return (
    <>
      Voicemail · Added to queue <strong>{node.queue}</strong>
    </>
  );
}
